import * as React from "react";
import styled, { ThemeProvider } from "styled-components";

import { colors } from "../../../common/utils/style";

type BaseProps = {
  className?: string;
  provider: "facebook" | "twitter";
} & React.HTMLAttributes<any>;

const BaseButton: React.SFC<BaseProps> = ({ provider, ...rest }) => {
  return (
    <ThemeProvider theme={{ provider }}>
      <Base {...rest}>
        <i className={`icon-${provider}`} />
      </Base>
    </ThemeProvider>
  );
};

type Props = Omit<BaseProps, "provider">;

export const FacebookButton: React.SFC<Props> = props => {
  return <BaseButton {...props} provider="facebook" />;
};

export const TwitterButton: React.SFC<Props> = props => {
  return <BaseButton {...props} provider="twitter" />;
};

const Base = styled.span`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${props => (props.theme.provider === "facebook" ? colors.facebookText : "#55acee")};
  color: white;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: transform 150ms ease-out;
  &:hover {
    transform: scale(1.1);
  }
`;



// WEBPACK FOOTER //
// ./frontend/src/common/components/sns/RoundButtons.tsx